import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import EnterpriseIcon, { BookmarkFilledIcon, FlagFilledIcon, HeartFilledIcon, LockLockedIcon, PinFilledIcon, StarFilledIcon, VisibleShowIcon, BookmarkIcon, FlagIcon, HeartIcon, LockUnlockedIcon, PinIcon, StarIcon, VisibleHideIcon } from '@enterprise-ui/icons';
import classnames from 'classnames';
import React__default from 'react';
import alertUserOfDeprecatedProps from '../../utils/deprecation.js';
import useCanvasId from '../../utils/useCanvasId.js';

var _excluded = ["className", "id", "clickable", "checked", "data-testid", "disabled", "onChange", "onClick", "size", "display", "error"];
var checkedIcons = {
  bookmark: BookmarkFilledIcon,
  flag: FlagFilledIcon,
  heart: HeartFilledIcon,
  lock: LockLockedIcon,
  pin: PinFilledIcon,
  star: StarFilledIcon,
  visible: VisibleShowIcon
};
var uncheckedIcons = {
  bookmark: BookmarkIcon,
  flag: FlagIcon,
  heart: HeartIcon,
  lock: LockUnlockedIcon,
  pin: PinIcon,
  star: StarIcon,
  visible: VisibleHideIcon
};
var InputIconToggle = function InputIconToggle(_ref) {
  var className = _ref.className,
    id = _ref.id,
    _ref$clickable = _ref.clickable,
    clickable = _ref$clickable === void 0 ? false : _ref$clickable,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    dataTestId = _ref['data-testid'],
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'normal' : _ref$size,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'star' : _ref$display;
    _ref.error;
    var otherProps = _objectWithoutProperties(_ref, _excluded);
  alertUserOfDeprecatedProps('InputIconToggle', otherProps);
  var uuid = useCanvasId(id, 'IconToggle');
  var finalClasses = classnames('C-IconToggle', _defineProperty(_defineProperty(_defineProperty(_defineProperty({
    '--clickable': clickable || onChange || onClick
  }, "--display-".concat(display), display), "--size-".concat(size), size), "isDisabled", disabled), "isSelected", checked), className);
  if (!id) {
    console.error("Hey Canvas user! The IconToggle requires a unique id because it is a form element.");
  }
  var handleOnClick = function handleOnClick(e) {
    if (onClick && typeof onClick === 'function') {
      onClick(e);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: finalClasses,
    "data-testid": dataTestId && "".concat(dataTestId, "_container")
  }, otherProps), /*#__PURE__*/React__default.createElement("input", {
    checked: checked,
    className: "C-IconToggle__checkbox",
    id: uuid,
    "data-testid": dataTestId,
    type: "checkbox",
    "aria-label": otherProps['aria-label'] ? otherProps['aria-label'] : "".concat(display, " ").concat(checked ? 'checked' : 'unchecked'),
    disabled: disabled,
    onChange: onChange,
    onClick: handleOnClick
  }), /*#__PURE__*/React__default.createElement("label", {
    className: "C-IconToggle__container",
    htmlFor: uuid
  }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "icon--checked",
    size: "inline",
    icon: checkedIcons[display]
  }), /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    className: "icon--unchecked",
    size: "inline",
    icon: uncheckedIcons[display]
  })));
};
InputIconToggle.displayName = 'Input.IconToggle';

export { InputIconToggle as default };
